import { Component  } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-evaluacion-operacion',
  templateUrl: './evaluacion-operacion.component.html',
  styleUrls: ['./evaluacion-operacion.component.scss']
})
export class EvaluacionOperacionComponent   {

  constructor(
    private loginService: LoginService
  ) { }


  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
